module.exports = __webpack_public_path__ + "static/media/pagenotfound.cfb49f55.svg";